export const CONDITION_CONTROL_STATUS_LABELS: Record<string, string> = {
  well_controlled: "Well Controlled",
  at_goal: "At Goal",
  fair_control: "Fair Control",
  poorly_controlled: "Poorly Controlled",
  uncontrolled: "Uncontrolled",
  improving: "Improving",
  stable: "Stable",
};

/**
 * A placeholder value for an ID that is not ready yet.
 *
 * When using react-query, non-nullable values are often required
 * arguments. This value can be used to indicate that the value is not ready yet.
 *
 * @example
 * ```tsx
 * useGetEncounterById(encounterId ?? NUMBER_ID_NOT_READY, {
 *   query: {
 *     enabled: !!encounterId,
 *   },
 * });
 * ```
 */
export const NUMBER_ID_NOT_READY = -1;

/**
 * A placeholder value for a string ID that is not ready yet.
 *
 * When using react-query, non-nullable values are often required
 * arguments. This value can be used to indicate that the value is not ready yet.
 *
 * @example
 * ```tsx
 * useGetEncounterById(encounterId ?? STRING_ID_NOT_READY, {
 *   query: {
 *     enabled: !!encounterId,
 *   },
 * });
 * ```
 */
export const STRING_ID_NOT_READY = "";
